import React from "react"
import { connect } from "react-redux"
import LocalTimeStamp from "../../common/LocalTimeStamp"
import TaskDetail from "./TaskDetail"
import TaskCell from "./TaskCell"
import _ from "lodash";

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
})

function TasksOverviewList({ props, onChange, onConversationStarted, onViewSourceConversation, currentPage, totalPages, handlePageChange, activeTab, isLoading, autoOpenTaskId, onAutoOpenConsumed, deepLinkedTask }) {
    const [tasks, setTasks] = React.useState(props.tasks.tasks);
    const matchesAutoOpenId = (id) => autoOpenTaskId != null && String(id) === String(autoOpenTaskId);
    const deepLinkedInList = deepLinkedTask && tasks.content && tasks.content.some(t => String(t.id) === String(deepLinkedTask.id));

    React.useEffect(() => {
        setTasks(props.tasks.tasks);
    }, [props.tasks])


    const onTaskChange = (t) => {
        onChange(t);
    }

    const getStatusLabel = (status) => {
        const labels = {
            'OVERDUE': 'Overdue',
            'OPEN': 'Upcoming',
            'IN_PROGRESS': 'In Progress',
            'CLOSED': 'Closed'
        };
        return labels[status] || '';
    };

    const deepLinkModal = (deepLinkedTask && !deepLinkedInList) ? (
        <TaskDetail
            key={`deep-${deepLinkedTask.id}`}
            task={deepLinkedTask}
            onChange={onTaskChange.bind(this)}
            props={props}
            onConversationStarted={onConversationStarted}
            onViewSourceConversation={onViewSourceConversation}
            taskActionTypes={props.tasks.taskActionTypes}
            user={props.user}
            opened={matchesAutoOpenId(deepLinkedTask.id)}
            onAutoOpenConsumed={onAutoOpenConsumed}
        >
            <span style={{ display: 'none' }} aria-hidden="true" />
        </TaskDetail>
    ) : null;

    return (
        tasks.content && tasks.content.length > 0 ?
            <div className="tasksList tableView">
                {deepLinkModal}
                {
                    // Flat list - no status grouping (server already filtered by tab)
                    _.map(tasks.content, function (t) {
                        return (
                            <TaskDetail task={t} onChange={onTaskChange.bind(this)} props={props} onConversationStarted={onConversationStarted}
                                onViewSourceConversation={onViewSourceConversation} key={t.id} taskActionTypes={props.tasks.taskActionTypes}
                                user={props.user}
                                opened={matchesAutoOpenId(t.id)}
                                onAutoOpenConsumed={onAutoOpenConsumed}>
                                <TaskCell
                                    taskStatus={t.status}
                                    taskTitle={t.type.name}
                                    taskAssignee={t.assignee ? t.assignee.readableName : ""}
                                    contactInfo={t.contact ? t.contact.readableName : ""}
                                    taskReportedDate={
                                        <LocalTimeStamp utcTimestamp={t.createdAt} format={"MMMM D"} utc={false} />
                                    }
                                    taskDueDate={
                                        <LocalTimeStamp utcTimestamp={t.dueDate} format={"MMMM D"} utc={false} />
                                    }
                                />
                            </TaskDetail>
                        )
                    })
                }
            </div>
        :
            // Empty state - 508c compliant (only show if not loading)
            !isLoading ? (
                <div className="emptyState" role="status" aria-live="polite">
                    {deepLinkModal}
                    <p>No {getStatusLabel(activeTab)} tasks found.</p>
                </div>
            ) : null
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(TasksOverviewList);
